var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidthFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_52)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2929 48.2929C14.9024 48.6834 14.9024 49.3166 15.2929 49.7071L21.6569 56.0711C22.0474 56.4616 22.6805 56.4616 23.0711 56.0711C23.4616 55.6805 23.4616 55.0474 23.0711 54.6569L17.4142 49L23.0711 43.3431C23.4616 42.9526 23.4616 42.3195 23.0711 41.9289C22.6805 41.5384 22.0474 41.5384 21.6569 41.9289L15.2929 48.2929ZM180.707 49.7071C181.098 49.3166 181.098 48.6834 180.707 48.2929L174.343 41.9289C173.953 41.5384 173.319 41.5384 172.929 41.9289C172.538 42.3194 172.538 42.9526 172.929 43.3431L178.586 49L172.929 54.6568C172.538 55.0474 172.538 55.6805 172.929 56.0711C173.319 56.4616 173.953 56.4616 174.343 56.0711L180.707 49.7071ZM16 50L17.9524 50L17.9524 48L16 48L16 50ZM21.8571 50L25.7619 50L25.7619 48L21.8571 48L21.8571 50ZM29.6667 50L33.5714 50L33.5714 48L29.6667 48L29.6667 50ZM37.4762 50L41.381 50L41.381 48L37.4762 48L37.4762 50ZM45.2857 50L49.1905 50L49.1905 48L45.2857 48L45.2857 50ZM53.0952 50L57 50L57 48L53.0952 48L53.0952 50ZM60.9048 50L64.8095 50L64.8095 48L60.9048 48L60.9048 50ZM68.7143 50L72.619 50L72.619 48L68.7143 48L68.7143 50ZM76.5238 50L80.4286 50L80.4286 48L76.5238 48L76.5238 50ZM84.3333 50L88.2381 50L88.2381 48L84.3333 48L84.3333 50ZM92.1429 50L96.0476 50L96.0476 48L92.1429 48L92.1429 50ZM99.9524 50L103.857 50L103.857 48L99.9524 48L99.9524 50ZM107.762 50L111.667 50L111.667 48L107.762 48L107.762 50ZM115.571 50L119.476 50L119.476 48L115.571 48L115.571 50ZM123.381 50L127.286 50L127.286 48L123.381 48L123.381 50ZM131.19 50L135.095 50L135.095 48L131.19 48L131.19 50ZM139 50L142.905 50L142.905 48L139 48L139 50ZM146.81 50L150.714 50L150.714 48L146.81 48L146.81 50ZM154.619 50L158.524 50L158.524 48L154.619 48L154.619 50ZM162.429 50L166.333 50L166.333 48L162.429 48L162.429 50ZM170.238 50L174.143 50L174.143 48L170.238 48L170.238 50ZM178.048 50L180 50L180 48L178.048 48L178.048 50Z",
    fill: "url(#paint0_linear_163_52)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 86,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 86,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_52",
    x1: 180,
    y1: 49.5,
    x2: 16,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#007FFF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FFF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidthFull);
export default __webpack_public_path__ + "static/media/width_full.b473c2bed8dc277722f9718d628226cc.svg";
export { ForwardRef as ReactComponent };